const requireData = require.context('.', false, /^(?!\.\/(index|partners)).*\.js$/)
let data = {}

requireData.keys().forEach(file => {
  data = {...data, ...requireData(file).default}
})

export default data



// WEBPACK FOOTER //
// ./src/data/index.js